import { Routes } from '@angular/router';
import { authGuard } from './auth-guard';
import { mfaEnrollGuard } from './mfa-enroll-guard';

export const routes: Routes = [
  { path: 'login', loadComponent: () => import('./login/login').then((m) => m.Login) },
  // 邀请注册：码由邮件链接携带（/register?code=xxx），不开放自助注册入口。
  { path: 'register', loadComponent: () => import('./register/register').then((m) => m.Register) },
  {
    path: 'auth/callback',
    loadComponent: () => import('./auth-callback/auth-callback').then((m) => m.AuthCallback),
  },
  {
    path: '',
    loadComponent: () => import('./layout/layout').then((m) => m.Layout),
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        canActivate: [mfaEnrollGuard],
        loadComponent: () => import('./dashboard/dashboard').then((m) => m.Dashboard),
      },
      {
        path: 'apikeys',
        canActivate: [mfaEnrollGuard],
        loadComponent: () => import('./apikeys/apikeys').then((m) => m.ApiKeys),
      },
      {
        path: 'security',
        loadComponent: () => import('./security/security').then((m) => m.Security),
      },
      {
        path: 'logs',
        loadComponent: () => import('./logs/logs').then((m) => m.Logs),
      },
      {
        path: 'settings',
        loadComponent: () => import('./settings/settings').then((m) => m.Settings),
      },
      // 所有权转移确认落地页：邮件链接指向此处。挂在 authGuard 下——
      // token 只证明「这封邮件发给你了」，真正的身份以登录态为准（后端会比对邮箱）。
      {
        path: 'enterprise/transfer/accept',
        loadComponent: () =>
          import('./enterprise/transfer-accept').then((m) => m.TransferAccept),
      },
      {
        path: 'profile',
        loadComponent: () => import('./profile/profile').then((m) => m.Profile),
      },
      {
        path: 'accounts',
        loadComponent: () => import('./accounts/accounts').then((m) => m.Accounts),
      },
      {
        path: 'transactions',
        loadComponent: () => import('./transactions/transactions').then((m) => m.Transactions),
      },
      {
        path: 'payees',
        loadComponent: () => import('./payees/payees').then((m) => m.Payees),
      },
      {
        path: 'transfer',
        loadComponent: () => import('./transfer/transfer').then((m) => m.Transfer),
      },
      // 「使用者」= 企业成员管理（谁能登录、操作这家企业）——原 /enterprise/members 迁到此处。
      // 原 /users（关键人员/董事受益人）已废除：那些只在企业档案「受益人與關鍵人員」展示，不再单列。
      {
        path: 'users',
        canActivate: [mfaEnrollGuard],
        loadComponent: () => import('./enterprise/members').then((m) => m.EnterpriseMembers),
      },
      // 虚拟卡（内部虚拟卡：储值卡 / 额度卡 / 交易 / 风控）
      {
        path: 'cards/stored',
        canActivate: [mfaEnrollGuard],
        loadComponent: () => import('./cards/stored-cards').then((m) => m.StoredCards),
      },
      {
        path: 'cards/credit',
        canActivate: [mfaEnrollGuard],
        loadComponent: () => import('./cards/credit-cards').then((m) => m.CreditCards),
      },
      {
        path: 'cards/transactions',
        canActivate: [mfaEnrollGuard],
        loadComponent: () => import('./cards/card-transactions').then((m) => m.CardTransactions),
      },
      {
        path: 'cards/risk',
        canActivate: [mfaEnrollGuard],
        loadComponent: () => import('./cards/card-risk').then((m) => m.CardRisk),
      },
      {
        path: 'cards/holders',
        canActivate: [mfaEnrollGuard],
        loadComponent: () => import('./cards/cardholders').then((m) => m.Cardholders),
      },
      // 数据统计（占位页，功能建设中）
      {
        path: 'reports',
        canActivate: [mfaEnrollGuard],
        data: { titleKey: 'nav.reports' },
        loadComponent: () => import('./placeholder/placeholder').then((m) => m.Placeholder),
      },
      {
        path: 'statements',
        canActivate: [mfaEnrollGuard],
        data: { titleKey: 'nav.statements' },
        loadComponent: () => import('./placeholder/placeholder').then((m) => m.Placeholder),
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    ],
  },
  { path: '**', redirectTo: 'login' },
];
